import { render, staticRenderFns } from "./ScheduleWeekSwitch.vue?vue&type=template&id=8a6b0932&scoped=true&"
import script from "./ScheduleWeekSwitch.vue?vue&type=script&lang=js&"
export * from "./ScheduleWeekSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleWeekSwitch.vue?vue&type=style&index=0&id=8a6b0932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6b0932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
